import { FilterOperator } from '../../../types.generated';

export const USER_SEARCH_QUERY_FILTER = [
    {
        and: [
            {
                field: 'active',
                values: ['true'],
            },
            {
                field: 'title',
                values: ['GUEST'],
                condition: FilterOperator.Contain,
                negated: true,
            },
        ],
    },
];
